import { TravelTypeWithHousing } from '@repo/utils'
import clsx from 'clsx'
import { useRouter } from 'next/router'
import React, { ReactNode } from 'react'

import s from './styles.module.scss'

import { TravelTypeModeEnum } from './travel-type-container.enum'
import { TravelTypeIcon } from '../travel-type-icon/TravelTypeIcon'
import { getTravelTypeClassNameByEnum } from '../travel-type-picker.utils'
import { breakpoints, useMediaQuery } from '../../../../lib/hooks'
import { useTravelTypeContext } from '../../../contexts'

const TravelTypeContainer = ({
  label,
  containerTravelType,
  displayBorder,
  minStyle,
  mode = TravelTypeModeEnum.DEFAULT,
}: {
  label: ReactNode
  containerTravelType: TravelTypeWithHousing
  displayBorder?: boolean
  minStyle?: boolean
  mode?: TravelTypeModeEnum
}) => {
  const { setTravelType, travelType } = useTravelTypeContext()
  const { replace, query, pathname } = useRouter()
  const hasDomainQuery = typeof query?.domain === 'string'

  const updateUrlParams = () => {
    replace(
      {
        pathname,
        query: {
          ...query,
          travelType: containerTravelType,
        },
      },
      hasDomainQuery
        ? `${pathname.replace('_sites/[domain]', '')}?travelType=${containerTravelType}`
        : undefined,
      { shallow: true },
    )
  }

  const isMobile = useMediaQuery(breakpoints.newMobile)

  const isSelected = travelType === containerTravelType

  return (
    <div
      onClick={() => {
        setTravelType(containerTravelType)
        updateUrlParams()
      }}
      className={clsx(s[getTravelTypeClassNameByEnum(mode)], {
        [s.selected]: isSelected,
        [s.border]: displayBorder,
        [s.minStyle]: minStyle,
      })}
    >
      {!minStyle ? (
        <>
          {!isMobile ? (
            <TravelTypeIcon travelType={containerTravelType} />
          ) : null}
          <span className={clsx({ [s.mobileLabel]: isMobile })}>{label}</span>
        </>
      ) : (
        <TravelTypeIcon travelType={containerTravelType} />
      )}
    </div>
  )
}

export default TravelTypeContainer
